{
  "until": "{{duration}} hasta {{prayer}}",
  "begin_focus": "Iniciar enfoque",
  "add_task": "Añadir tarea",
  "more_tasks": "+{{count}} más",
  "fajr_at": "Fajr a las {{time}}",
  "schedule_title": "Hoy",
  "plan_my_day": "Planificar mi día",
  "planning": "Planificando…",
  "suggested": "Sugerido",
  "keep_plan": "Mantener plan",
  "undo_plan": "Deshacer",
  "plan_error": "No se pudo planificar ahora. Inténtalo de nuevo.",
  "plan_empty": "Nada que planificar aún — añade una tarea primero.",
  "plan_settled": "Todo está ya en su lugar.",
  "view_list": "Lista",
  "view_switch_aria": "Cambiar entre vista de lista y de día",
  "unassigned": "Sin programar",
  "assign_title": "Bloque de oración",
  "no_block": "Sin bloque",
  "assign_aria": "Asignar a un bloque de oración",
  "open_schedule_aria": "Abrir el horario de hoy",
  "focus_session_label": "{{block}} · Enfoque",
  "block_hero": "Trabajo profundo hasta {{prayer}}",
  "moments_away": "{{prayer}} está a instantes",
  "block_clear": "Todo listo — descansa hasta {{prayer}}",
  "alhamdulillah": "Alhamdulillah",
  "exit_hint": "Esc para salir en silencio",
  "exit_hint_touch": "Toca ✕ para salir en silencio",
  "mark_done_aria": "Marcar tarea como completada",
  "quick_add_placeholder": "Añadir a este bloque…",
  "focus_task_aria": "Enfocarse en esta tarea"
}
